import {useTranslation} from 'react-i18next';
import {cn} from '@chekinapp/ui';
import {PropertyLinkPhoto} from 'components/arrival';
import {DARK_INK_VARS} from 'components/SplashScreen/splashInk';
import {SplashStatus} from 'components/SplashScreen/SplashStatus';
import {
  SPLASH_TIMING,
  getAnnounceKey,
  type SplashStage,
} from 'components/SplashScreen/constants';
import styles from './entrance.module.css';

type Props = {
  stage: SplashStage;
  elapsedMs: number;
  onRetry: () => void;
  isLeaving?: boolean;
};

function EntranceBackdrop({stage, elapsedMs, onRetry, isLeaving}: Props) {
  const {t} = useTranslation();
  const announceKey = getAnnounceKey(stage);

  return (
    <div
      role="status"
      aria-live="polite"
      aria-busy={!isLeaving}
      className={cn(
        styles.root,
        styles.still,
        'transition-[opacity,visibility] ease-in-out motion-reduce:transition-none',
        isLeaving && 'pointer-events-none invisible opacity-0',
      )}
      style={{transitionDuration: `${SPLASH_TIMING.curtain}ms`, ...DARK_INK_VARS}}
    >
      <div className={styles.backdrop}>
        <PropertyLinkPhoto />
      </div>
      <SplashStatus
        stage={stage}
        elapsedMs={elapsedMs}
        onRetry={onRetry}
        className="absolute inset-x-0 top-1/2 z-[2] -translate-y-1/2 px-6"
      />
      <span className="sr-only">{announceKey ? t(announceKey) : null}</span>
    </div>
  );
}

export {EntranceBackdrop};
